import { DolfinParser } from './base'
import {
  addDays,
  addMonths,
  endOfMonth,
  endOfQuarter,
  endOfYear,
  format,
  parseISO,
  startOfMonth,
  startOfQuarter,
  startOfYear,
  subDays,
  subMonths
} from 'date-fns'

export class FunctionParser extends DolfinParser {
  execute(formula: string): string {
    const tags = this.joinFunctionArguments(formula)

    return tags
      .map(tag => {
        const fnName = tag.split(' ')[0]
        if (this.matcher?.test(fnName)) {
          return this.applyFunction(fnName, tag)
        }

        return tag
      })
      .join(' ')
  }

  private applyFunction(fnName: string, tag: string) {
    let args = tag.replace(`${fnName} `, '')

    const firstArg = args.split(' ')[0]
    if (this.matcher?.test(firstArg)) {
      args = this.applyFunction(firstArg, args)
    }
    const secondArg = args.split(' ')[1]
    if (this.matcher?.test(secondArg)) {
      const currentFirstArg = args.split(' ')[0]
      args =
        args.split(' ')[0] +
        ' ' +
        this.applyFunction(secondArg, args.replace(new RegExp(`^${currentFirstArg} `), ''))
    }

    if (fnName === 'startofmonth') {
      return `'${format(startOfMonth(this.getDateValue(args)), 'yyyy-MM-dd')}'`
    } else if (fnName === 'startofquarter') {
      return `'${format(startOfQuarter(this.getDateValue(args)), 'yyyy-MM-dd')}'`
    } else if (fnName === 'startofyear') {
      return `'${format(startOfYear(this.getDateValue(args)), 'yyyy-MM-dd')}'`
    } else if (fnName === 'endofmonth') {
      return `'${format(endOfMonth(this.getDateValue(args)), 'yyyy-MM-dd')}'`
    } else if (fnName === 'endofquarter') {
      return `'${format(endOfQuarter(this.getDateValue(args)), 'yyyy-MM-dd')}'`
    } else if (fnName === 'endofyear') {
      return `'${format(endOfYear(this.getDateValue(args)), 'yyyy-MM-dd')}'`
    } else if (fnName === 'asdate') {
      return `new Date(${args})`
    } else if (fnName === 'plusdays') {
      const fnArgs = args
        .replace('new Date', 'new_Date')
        .split(' ')
        .map(a => a.replace('new_Date', 'new Date'))
      return `'${format(addDays(this.getDateValue(fnArgs[1]), Number(fnArgs[0])), 'yyyy-MM-dd')}'`
    } else if (fnName === 'minusdays') {
      const fnArgs = args
        .replace('new Date', 'new_Date')
        .split(' ')
        .map(a => a.replace('new_Date', 'new Date'))
      return `'${format(subDays(this.getDateValue(fnArgs[1]), Number(fnArgs[0])), 'yyyy-MM-dd')}'`
    } else if (fnName === 'plusmonths') {
      const fnArgs = args
        .replace('new Date', 'new_Date')
        .split(' ')
        .map(a => a.replace('new_Date', 'new Date'))
      return `'${format(addMonths(this.getDateValue(fnArgs[1]), Number(fnArgs[0])), 'yyyy-MM-dd')}'`
    } else if (fnName === 'minusmonths') {
      const fnArgs = args
        .replace('new Date', 'new_Date')
        .split(' ')
        .map(a => a.replace('new_Date', 'new Date'))
      return `'${format(subMonths(this.getDateValue(fnArgs[1]), Number(fnArgs[0])), 'yyyy-MM-dd')}'`
    } else if (fnName === 'numquarter') {
      return `${format(this.getDateValue(args), 'Q')}`
    }

    return tag
  }

  private getDateValue(date: string): number | Date {
    if (!date || date === "'null'" || date === "''") {
      date = "'1970-01-01'"
    }

    return date.startsWith("'")
      ? parseISO(date.replace(/'/g, ''))
      : new Function(`return ${date}`)()
  }
}
